import { inject, injectable } from 'inversify'
import {
  IAppErrorFactory,
  IUpdateEmailUseCase,
  IViewerService,
  UpdateEmailUseCaseInput,
  UpdateEmailUseCaseOutput,
  UpdatePasswordUseCaseOutput,
} from '@/types'
import symbols from '@/symbols'

@injectable()
export default class UpdateEmailInteractor implements IUpdateEmailUseCase {
  @inject(symbols.IViewerService) private viewerService: IViewerService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: UpdateEmailUseCaseInput): Promise<UpdateEmailUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      await this.viewerService.updateMe(input)

      output.isSuccessful = true
    } catch (e) {
      output.isSuccessful = false
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: 'メールアドレスの変更に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): UpdatePasswordUseCaseOutput {
    return {
      isSuccessful: false,
      error: null,
    }
  }
}
